import React, { useState } from 'react';
import axios from '../../services/api-axios';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from './icons';
import styles from './RegistrationForm.module.css';

function RegistrationForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    function handleEmailChange(event) {
        setEmail(event.target.value);
    }

    function handlePasswordChange(event) {
        setPassword(event.target.value);
    }
    
    const handleSubmit = async () => {
        if (!email || !password) {
            setError('Please fill in all fields');
            return;
        }

        if (password.length < 6) {
            setError('Password must be at least 6 characters long');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            console.log(email, password);
            const res = await axios.post('/api/auth/register', {
                email: email,
                password: password
            });
            
            let token = res.data["jwt-token"];
            localStorage.setItem("SavedToken", 'Bearer ' + token);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            
            setSuccess(true);
            setError(null);
        } catch (err) { 
            setError(err.message || 'Registration failed');
            setSuccess(false);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.formContainer}>
            <div className={styles.header}>
                <h2 className={styles.title}>
                    Create Account
                </h2>
                <p className={styles.subtitle}>
                    Join our gaming community today
                </p>
            </div>

            <form onSubmit={(e) => e.preventDefault()}>
                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        Email Address
                    </label>
                    <div className={styles.inputWrapper}>
                        <MailIcon className={styles.inputIcon} />
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Enter your email..."
                            className={styles.input}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        Password
                    </label>
                    <div className={styles.inputWrapper}>
                        <LockIcon className={styles.inputIcon} />
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            value={password}
                            onChange={handlePasswordChange}
                            placeholder="Create a password..."
                            className={styles.input}
                        />
                        <button
                            type="button"
                            className={styles.togglePassword}
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                        >
                            {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                        </button>
                    </div>
                    <p className={styles.helperText}>
                        Password must be at least 6 characters long
                    </p>
                </div>

                {/* Success Message */}
                {!error && success && (
                    <div className={styles.successMessage}>
                        <span>✅</span>
                        Successfully created profile! Welcome to the community.
                    </div>
                )}

                {/* Error Message */}
                {error && (
                    <div className={styles.errorMessage}>
                        <span>⚠️</span>
                        Error: {error}
                    </div>
                )}

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    type="button"
                    className={styles.submitButton}
                >
                    {loading ? (
                        <>
                            <div className={styles.spinner} />
                            Creating Account...
                        </>
                    ) : (
                        <>
                            🚀 Create Account
                        </>
                    )}
                </button>
            </form>
        </div>
    );
}

export default RegistrationForm;